module.exports = __webpack_public_path__ + "media/images/background/subheader-bd3b04df2c5c85b2639838232a6a5c83.jpg";